import styles from "./Faturas.module.css";
import { useEffect, useState } from "react";
import axios from "axios";
import load from "../../../Images/loading.gif";
import { Link } from "react-router-dom";

function Faturas({ user }) {
    const [faturas, setFaturas] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`https://eclipsebots.com/api/faturas/${user.id}`, { withCredentials: true })
            .then((res) => setFaturas(res.data))
            .catch(() => setFaturas([]))
            .finally(() => setLoading(false));
    }, [user]);


    if (loading) {
        return <div className={styles.content}>
            <div className={`${styles.size} ${styles.loading}`}>
                <img src={load} width="20px" height="20px" alt="loading" />
            </div>
        </div>
    }

    return (
        <div className={styles.faturas}>
            <div className={styles.title}>Faturas</div>
            {faturas.length === 0 ? (
                <div className={styles.noData}>
                    Não possui nenhuma fatura de momento.
                </div>
            ) : (
                <div className={styles.fat}>
                    {faturas.map((fatura, index) => {
                        const isFirst = index === 0;
                        const isLast = index === faturas.length - 1;

                        return (
                            <Link to={`${fatura.invoiceId}`}>
                                <div key={fatura.invoiceId} className={`${styles.fatura} ${isFirst ? styles.first : ""} ${isLast ? styles.last : ""}`}>
                                    {fatura.serviceImage && (
                                        <div className={styles.image}>
                                            <img src={fatura.serviceImage} alt="Imagem da App" />
                                        </div>
                                    )}
                                    <div className={`${styles.emoji} ${styles.imagem}`}>
                                        {getEmoji(fatura.status)}
                                    </div>
                                    <div className={`${styles.name} ${styles.imagem}`}>
                                        Fatura <strong>#{fatura.invoiceId}</strong> {fatura.status === "paid" ? (
                                            <span>Paga a {new Date(fatura.paidAt).toLocaleString()}</span>
                                        ) : `${fatura.status === "pending" ? "por pagar" : "com o pagamento cancelado"}. (Gerada a ${new Date(fatura.issuedAt).toLocaleString()})`}
                                    </div>
                                </div>
                            </Link>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

const getEmoji = (type) => {
    switch (type) {
        case "pending": return "🕒";
        case "cancelled": return "🔴";
        case "failed": return "🔴";
        case "paid": return "🟢";
        default: return "🔔";
    }
};

export default Faturas;